import React, { Component } from "react";
import PropTypes, { string } from "prop-types";
import { connect } from "react-redux";
import { actions as savedStateActions } from "../actions/savedState";
import Settings from "../settings";

export class SavedStateHandler extends Component {
  constructor() {
    super();

    this.timer = null;
  }

  shouldComponentUpdate(nextProps) {
    return (
      this.props.initialized !== nextProps.initialized ||
      this.props.lastLocalChange !== nextProps.lastLocalChange ||
      this.props.restored !== nextProps.restored ||
      this.props.authenticated !== nextProps.authenticated
    );
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.lastLocalChange !== prevProps.lastLocalChange &&
      this.props.restored
    ) {
      if (this.timer) {
        // Reset timer if a new change happens before saving the old change.
        clearTimeout(this.timer);
      }
      // Create a timer that saves the state x seconds after a change is detected.
      this.timer = setTimeout(this.saveState, Settings.stateSaveDelay);
    }

    if (
      this.props.initialized &&
      this.props.authenticated &&
      !this.props.restored
    ) {
      this.props.restoreState();
    }
  }

  saveState = () => {
    clearTimeout(this.timer);
    this.timer = null;
    this.props.saveState();
  };

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  render() {
    return null;
  }
}

SavedStateHandler.defaultProps = {
  lastLocalChange: null,
  lastSave: null
};

SavedStateHandler.propTypes = {
  savedStateLoading: PropTypes.bool.isRequired,
  lastLocalChange: PropTypes.number,
  lastSave: PropTypes.number,
  saveState: PropTypes.func.isRequired,
  restoreState: PropTypes.func.isRequired,
  initialized: PropTypes.bool.isRequired,
  currentUser: PropTypes.string.isRequired,
  authenticated: PropTypes.bool.isRequired,
  restored: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  savedStateLoading: state.savedState.savedStateLoading,
  lastLocalChange: state.savedState.lastLocalChange,
  lastSave: state.savedState.lastSave,
  authenticated: state.auth.authenticated,
  currentUser: state.auth.user.username || "",
  initialized: state.app.initialized,
  restored: state.savedState.restored
});

const mapActionHandlers = {
  saveState: savedStateActions.saveState,
  restoreState: savedStateActions.restoreState
};

export default connect(mapStateToProps, mapActionHandlers)(SavedStateHandler);



// WEBPACK FOOTER //
// ./app/components/SavedStateHandler.js